import * as yup from 'yup'

export const validationSchema = yup.object({
  groupName: yup
    .string('Enter group Name ')
    .required('Group Name is required'),
})
